import {
    Answer,
    Question,
    RootQuestionsState,
    useSupportCaseStore,
} from '../../../store/supportCaseStore';
import {
    Button,
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    Icons,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {useState} from 'react';
import styles from './rootQuestion.module.css';
import Choice from './Choice';

interface RootQuestionProps {
    questions: Question[];
    state: RootQuestionsState;
    questionOrderNumber: number;
    cardsLayout?: boolean;
}

const RootQuestion = ({
    questions,
    state,
    questionOrderNumber,
    cardsLayout = false,
}: RootQuestionProps) => {
    const submitAnswer = useSupportCaseStore(state => state.submitAnswer);
    const [selectedAnswer, setAnswer] = useState<Answer | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Card shadow={cardsLayout ? undefined : 'none'} noMargin={!cardsLayout}>
            <CardHeader
                noBorder={!!state.answer}
                noHorizontalPadding={!cardsLayout}
                noMargin={!cardsLayout}
            >
                <div className={styles.headerWrapper}>
                    <span className={styles.number}>{questionOrderNumber}</span>
                    {state.answer === null
                        ? 'Wat is er aan de hand?'
                        : state.answer.label}
                </div>
            </CardHeader>
            {state.answer === null && (
                <CardContent>
                    <div
                        style={{
                            display: 'flex',
                            columnGap: '2rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        {questions.map(question => {
                            return (
                                <div
                                    key={question.id}
                                    className={styles.questions}
                                >
                                    <div className={styles.label}>
                                        <Typography
                                            gutterBottom={true}
                                            weight={'bold'}
                                        >
                                            {question.label}
                                        </Typography>
                                    </div>
                                    <div className={styles.answers}>
                                        {question.answers.map(answer => {
                                            return (
                                                <Choice
                                                    key={answer.id}
                                                    label={answer.label}
                                                    choice={answer}
                                                    disabled={isLoading}
                                                    checked={
                                                        selectedAnswer?.id ===
                                                        answer.id
                                                    }
                                                    onClick={answer =>
                                                        setAnswer(
                                                            answer as Answer
                                                        )
                                                    }
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardContent>
            )}
            {state.answer === null && (
                <CardFooter noHorizontalPadding={!cardsLayout}>
                    <Button
                        label={selectedAnswer ? 'Volgende' : 'Maak een keuze'}
                        rightIcon={isLoading ? Icons.LOADING : Icons.CH_RIGHT}
                        type={
                            selectedAnswer && !isLoading
                                ? 'primary'
                                : 'disabled'
                        }
                        onClick={() => {
                            setIsLoading(true);
                            submitAnswer(
                                selectedAnswer as Answer,
                                null
                            ).finally(() => setIsLoading(false));
                        }}
                    />
                </CardFooter>
            )}
        </Card>
    );
};

export default RootQuestion;
